import React, { useEffect, useState } from 'react';
import { Badge, Popover } from 'antd/lib';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { switchLanguage, toggleCollapsedSideNav } from '../../appRedux/actions';
import languageData from '../Topbar/languageData';
import CustomScrollbars from '../../util/CustomScrollbars';

function AppsNavigation() {
  const { locale } = useSelector(({ settings }: any) => settings);

  const [reminderCount, setReminderCount] = useState(0);
  const [showNotifyCount, setShowNotifyCount] = useState(true);

  const dispatch = useDispatch();
  const dashboard = useSelector(({ dashboard }: any) => dashboard);

  const { navCollapsed } = useSelector(({ sideNav }: any) => sideNav);

  const languageMenu = () => (
    // <CustomScrollbars className="gx-popover-lang-scroll">
    <ul className="gx-sub-popover gx-p-0">
      {languageData.map((language) => (
        <li
          className="gx-media gx-pointer"
          key={JSON.stringify(language)}
          onClick={(e) => dispatch(switchLanguage(language))}
        >
          <i className={`flag flag-24 gx-mx-2 flag-${language.icon}`} />
          <span className="gx-language-text">{language.name}</span>
        </li>
      ))}
    </ul>
    // </CustomScrollbars>
  );

  useEffect(() => {
    const { automationStatistics } = dashboard;
    automationStatistics && setReminderCount(automationStatistics.notifyCount);
  }, [dashboard]);

  return (
    <ul
      style={{ paddingLeft: `${locale.direction === 'ltr' && '40px'}` }}
      className="gx-app-nav"
    >
      {/* <li>
      <i className="icon icon-search-new" />
    </li> */}
      <Link
        onClick={() => {
          dispatch(toggleCollapsedSideNav(!navCollapsed));
        }}
        to={`${reminderCount ? '/efficiency/todo' : '/team-work/home'}`}
        className="gx-d-flex"
      >
        <li style={{ position: 'relative' }} className="gx-p-2">
          {showNotifyCount && reminderCount && reminderCount > 0 ? (
            <div
              style={{
                position: 'absolute',
                minWidth: '1rem',
                height: '1rem',
                backgroundColor: 'red',
                left: 0,
              }}
              className="gx-mt-2 gx-rounded-sm gx-d-flex gx-justify-content-center gx-align-items-center"
            >
              <span className="gx-text-white gx-fs-sm">{reminderCount}</span>
            </div>
          ) : null}
          <i className="icon icon-notification" />
        </li>
      </Link>
      <li>
        <i className="icon icon-chat-new" />
      </li>

      <li>
        <Popover
          overlayClassName="gx-popover-horizantal gx-p-0"
          placement="bottomRight"
          content={languageMenu()}
          trigger="click"
          className="gx-p-0"
        >
          <i className={`flag flag-24 flag-${locale.icon}`} />
        </Popover>
      </li>
    </ul>
  );
}

export default AppsNavigation;
